import React from 'react'
import { useSelector } from 'react-redux';
import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js'

const ZoomInOut = () => {
  const state = useSelector((state)=>state.reducer)

    const zoomInOutfunc = (inout) => { // in - true, out - false
      const controls = state.const_var.controls
      const camera = controls?.object;
      let dir = new THREE.Vector3();
      camera.getWorldDirection(dir);
      dir.negate();
      let dist = controls?.getDistance();
      const maxDistance = controls?.maxDistance;

      let changedDistance = dist;
      if (inout) {
        if (changedDistance > 20) {
          changedDistance -= 20
        } else {
          changedDistance = 0.1;
        }
      }
      else {
        if (changedDistance < maxDistance - 20) {
          changedDistance += 20;
        } else {
          changedDistance = maxDistance;
        }
      }

      new TWEEN.Tween({ val: dist })
        .to({ val: changedDistance }, 500)
        .onUpdate(val => {
          camera.position.copy(controls.target).addScaledVector(dir, val.val);
        })
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();

      controls.update();

      animation();
    }
    const animation = () => {
      TWEEN.update();
      requestAnimationFrame(animation);
    }
  return (
    <div className='zoominoutwrapper'>
        <a onClick={e => zoomInOutfunc(true)}><span className="ico-icon-zoom-in icon"></span></a>
        <a onClick={e => zoomInOutfunc(false)}><span className="ico-icon-zoom-out icon"></span></a>
    </div>
  )
}

export default ZoomInOut;
